import styled from "styled-components";
import {HeaderArenasStyle} from "../../../../../themes/architecture/sections/theme-layout.interface";
import {HomepageHeaderArenaSkeletonDefaultBox} from "./home-page-header-arena-skeleton.default.box";

export const HomepageHeaderArenaSkeletonCasino888Box = styled(HomepageHeaderArenaSkeletonDefaultBox)`
    top: 50%;
    left: 50%;
    max-width: 219px;
    max-height: 186px;
    transform: translate(-50%, -50%);
    &::before {
        top: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "4rem" : 0};
        left: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "2rem" : 0};
        right: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "2rem" : 0};
        bottom: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "3rem" : 0};
        border-radius: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "40%" : "16px"};
    }
`;